import React, { useState, useEffect } from "react";
import {
  getFirestore,
  collection,
  getDocs,
  where,
  query,
  onSnapshot,
  doc,
  updateDoc,
} from "firebase/firestore";
import {
  Container,
  Row,
  Col,
  Card,
  Button,
  Spinner,
  Stack,
} from "react-bootstrap";
import ChatApp from "./ChatApp"; // Import the provided ChatApp component
import {
  TickIcon,
  TickIconFill,
  XWrongIconFill,
  PhoneIcon,
} from "../../Utils/SVGs";
import { BasicColor } from "../../Utils/constants";
import ClinicCardSelection from "./ClinicDropDown";
import VideoGalleryAdmin from "./VideoGalleryAdmin";

const DoctorChatDashboard = () => {
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updateLoading, setUpdateLoading] = useState(false); // Loading state for Firestore update
  const [showAllMsgs, setshowAllMsgs] = useState(true);
  const [filterSeen, setfilterSeen] = useState(false);
  const [unfilteredChats, setunfilteredChats] = useState([]);
  const db = getFirestore();
  const [showSelectClinic, setshowSelectClinic] = useState(false);
  const [showVideosManager, setshowVideosManager] = useState(false);

  useEffect(() => {
    localStorage.setItem("showAllMsgs", showAllMsgs);
    localStorage.setItem("filterSeenMsgs", filterSeen);
    if (!showAllMsgs) {
      setChats(chats.filter((chat) => chat.data.isFavourite === true));
    } else {
      setChats(unfilteredChats);
    }
    if (filterSeen) {
      setChats(chats.filter((chat) => chat.data.isOpen === false));
    }
  }, [showAllMsgs, filterSeen, unfilteredChats]);

  // Fetch all chat documents from Firestore
  useEffect(() => {
    const chatCollection = query(collection(db, "chats"));

    // Set up a real-time listener
    const unsubscribe = onSnapshot(
      chatCollection,
      (snapshot) => {
        const chatList = snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }));
        setChats(chatList);
        console.log("chatList", chatList);
        setunfilteredChats(chatList);
        setLoading(false);
      },
      (error) => {
        console.error("Error listening to chats:", error);
        setLoading(false);
      }
    );

    // Cleanup listener on component unmount
    return () => unsubscribe();
  }, [db]);

  const handleChatSelect = async (chatId) => {
    console.log("chat id id", chatId);
    setUpdateLoading(true);
    try {
      const chatRef = doc(db, "chats", chatId);
      await updateDoc(chatRef, {
        isOpen: true,
      });
      setSelectedChat(chatId);
      console.log("chatid", chatId);
    } catch (error) {
      console.error("Error updating chat:", error);
      alert("Failed to open chat. Please try again.");
    } finally {
      setUpdateLoading(false);
    }
  };

  const toggleFavourite = async (chatId, isfavourite) => {
    setUpdateLoading(true);
    try {
      const chatRef = doc(db, "chats", chatId);
      await updateDoc(chatRef, {
        isFavourite: !isfavourite,
      });
    } catch (error) {
      console.error("Error updating chat:", error);
      alert("Failed to open chat. Please try again.");
    } finally {
      setUpdateLoading(false);
    }
  };

  return (
    <Container className="mt-4">
      {!selectedChat ? (
        <>
          <div
            style={{
              margin: "10px",
              borderStyle: showSelectClinic ? "solid" : "",
              borderColor: "lightgray",
              borderRadius: "10px",
            }}
          >
            <Button
              style={{
                marginTop: "5px",
                backgroundColor: showSelectClinic ? "red" : BasicColor,
              }}
              onClick={() => setshowSelectClinic(!showSelectClinic)}
            >
              {showSelectClinic ? "Close" : "Select Clinic"}
            </Button>
            {showSelectClinic && <ClinicCardSelection />}
          </div>
          <hr />
          {
            <Button
              size="sm"
              variant={showVideosManager ? "disabled" : "secondary"}
              onClick={() => {
                setshowVideosManager(!showVideosManager);
              }}
            >
              {showVideosManager ? XWrongIconFill("red", 30) : "Manage Videos"}
            </Button>
          }
          {showVideosManager && <VideoGalleryAdmin />}
          <hr />
          <Stack direction="horizontal" gap={1}>
            <h5 style={{ paddingTop: "1%" }}>Show All: </h5>
            <Button
              size="sm"
              variant="disabled"
              style={{ marginRight: "50px" }}
              onClick={() => setshowAllMsgs(!showAllMsgs)}
            >
              {showAllMsgs
                ? TickIconFill("green", 20)
                : XWrongIconFill("red", 20)}
            </Button>
            <h5 style={{ paddingTop: "1%" }}>Filter Seen: </h5>
            <Button
              size="sm"
              variant="disabled"
              onClick={() => setfilterSeen(!filterSeen)}
            >
              {filterSeen
                ? TickIconFill("green", 20)
                : XWrongIconFill("red", 20)}
            </Button>
          </Stack>
          {loading ? (
            <Spinner animation="border" className="d-block mx-auto" />
          ) : chats.length === 0 ? (
            <p className="text-center">No chats available.</p>
          ) : (
            <Row>
              {chats.map((chat) => (
                <Col md={4} key={chat.id} className="mb-4">
                  <Card
                    style={{
                      backgroundColor: !chat.data.isOpen && "lightgray",
                    }}
                  >
                    <Card.Body>
                      <Button
                        variant="disabled"
                        onClick={() =>
                          toggleFavourite(chat.id, chat.data.isFavourite)
                        }
                      >
                        {chat.data.isFavourite
                          ? TickIconFill("green", 30)
                          : XWrongIconFill("red", 30)}
                      </Button>
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => {
                          const telHref = `tel:${chat.data.ptPhone}`;
                          window.location.href = telHref;
                        }}
                      >
                        {PhoneIcon("white", 20)}
                      </Button>

                      <Card.Title>{chat.data.ptName}</Card.Title>
                      <p>{chat.id}</p>
                      <Card.Text>
                        Last Message:{" "}
                        {chat.data.messages && chat.data.messages.length > 0
                          ? chat.data.messages[chat.data.messages.length - 1]
                              .note || "No text available"
                          : "No messages yet"}
                      </Card.Text>
                      <Button
                        variant="primary"
                        onClick={() => handleChatSelect(chat.id)}
                        disabled={updateLoading}
                      >
                        {updateLoading ? "Loading..." : "Open Chat"}
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          )}
        </>
      ) : (
        <>
          <ChatApp
            isDoctor={true}
            mrn={selectedChat}
            pName={chats.find((chat) => chat.id === selectedChat).data.ptName}
            pPhone={chats.find((chat) => chat.id === selectedChat).data.ptPhone}
            URL={chats.find((chat) => chat.id === selectedChat).data.chatUrl}
          />
          <Button
            variant="secondary"
            onClick={() => setSelectedChat(null)}
            className="mb-3"
            style={{ margin: "10px" }}
          >
            Back to Dashboard
          </Button>
        </>
      )}
    </Container>
  );
};

export default DoctorChatDashboard;
